import React from "react";
import Header from "@components/TalentHeader/TalentHeader";
import Footer from "@components/MainFooter/MainFooter";
import Filter from "@components/TalentFilter/TalentFilter";
import { Outlet } from "react-router-dom";
import "./Talent.scss";

const Talent: React.FC = () => {
  return (
    <div className="Talent">
      <main className="flex-fill main-content position-relative max-height-vh-100 border-radius-lg">
        <Header />
        <Filter />
        <div className="container px-5 py-3 mb-5">
          <Outlet />
        </div>
        <Footer />
      </main>
    </div>
  );
};

export default Talent;
